import { useLazyQuery, useMutation } from "@apollo/client/react";
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { JustificarMinutaDetalleItems } from './JustificarMinutaDetalleItems';
import './justificarMinutaGrilla.scss';

import moment from 'moment';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { TextInput } from '../../../components/textInput/TextInput';
import { CREATE_MINUTA } from '../../../data/graphQL/mutations/GenerarMinuta/createMinuta';
import { JUSTIFICAR_MINUTA_MANUAL } from '../../../data/graphQL/mutations/GenerarMinuta/justificarMinuta';
import { adaptJustificacionPeriodoFacturarArray, GET_JUSTIFICACION_PERIODO_FACTURAR } from '../../../data/graphQL/queries/GenerarMinuta/getJustificacionPeriodoFacturar';
import { GenerarMinutaDetalleDocs } from "../../GenerarMinuta/components/GenerarMinutaDetalleDocs";

export const JustificarMinutaDetalleContent = ({
  dataRegistro,
  idDelegacion,
  delegacion
}) => {
  const navigate = useNavigate();
  const [justificaciones, setJustificaciones] = useState([]);
  const [idJustificacionMasiva, setIdJustificacionMasiva] = useState(0);
  const [itemsEvaluacion, setItemsEvaluacion] = useState([]);
  const [itemsSeleccionados, setItemsSeleccionados] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [documentosSeleccionados, setDocumentosSeleccionados] = useState([]);
  const [documentosSAP, setDocumentosSAP] = useState([]);
  const [refetchConexiones, setRefetchConexiones] = useState(false);
  const location = useLocation();
  const allowedWrite = location.state.allowedWrite;

  const [getJustificaciones, { data: dataJustificaciones, loading: justificacionesLoading }] = useLazyQuery(GET_JUSTIFICACION_PERIODO_FACTURAR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataJustificaciones) return;
    setJustificaciones(adaptJustificacionPeriodoFacturarArray(dataJustificaciones.justificacionPendienteFacturar));
  }, [dataJustificaciones]);

  useEffect(() => {
    if (!justificacionesLoading)
      getJustificaciones();
  }, []);

  const disabledCheckbox = (row) => {
    return !allowedWrite;
  };

  // INICIO GENERAR

  const validarGenerar = () => {
    // al menos una conexión
    if (itemsSeleccionados.length === 0) {
      toast.error("Debe seleccionar al menos una conexión.");
      return false;
    }

    // documentos obligatorios
    const ids = documentos.filter((row, index) => {
      return documentosSeleccionados.includes(index + 1);
    }).map((elem) => {
      return elem.idDocMinuta;
    });

    if (documentosSAP.filter((x) => !ids.includes(x.idDocumentoMinuta)).length > 0) {
      toast.error("Faltan documentos obligatorios por incorporar.");
      return false;
    }

    return true;
  };

  const [createMinuta, { loading: createMinutaLoading }] = useMutation(CREATE_MINUTA, {
    onCompleted: (data) => {
      if (data.createMinuta.success) {
        toast.success(data.createMinuta.valorEsperado);
        setTimeout(() => navigate('/justificarMinuta'), 1000);
      } else {
        toast.error(data.createMinuta.valorEsperado);
      }
    }
  });

  const generateInput = () => {
    // conexiones
    let conexionesInput = [];
    itemsSeleccionados.map((conexion) => {
      conexionesInput.push(conexion.idConexion);
    });

    // documentos
    const documentosInput = documentos.filter((row, index) => {
      return documentosSeleccionados.includes(index + 1);
    }).map((elem) => {
      return {
        idDocumentoMinuta: elem.idDocMinuta,
        descripcion: elem.descripcion
      };
    });

    return {
      idEvaluacion: dataRegistro.idEvaluacion,
      idPaciente: dataRegistro.idPaciente,
      codClienteSAP: dataRegistro.codClienteSAP,
      idDelegacion: idDelegacion,
      precioDiario: dataRegistro.precioDiario,
      codPlanSAP: dataRegistro.codPlanSAP,
      observaciones: dataRegistro.observaciones,
      precioSAP: dataRegistro.precioSAP,
      idConexiones: conexionesInput,
      documentoMinuta: documentosInput
    };
  };

  const handleGenerar = () => {
    if (validarGenerar()) {
      const input = generateInput();
      createMinuta({ variables: { minutaInput: input } });
    }
  };

  // FIN GENERAR

  // INICIO JUSTIFICAR

  const [justificarMinuta, { loading: justificarMinutaLoading }] = useMutation(JUSTIFICAR_MINUTA_MANUAL, {
    onCompleted: (data) => {
      if (data.justificarMinutaManual.success) {
        toast.success(data.justificarMinutaManual.valorEsperado);
        setIdJustificacionMasiva(0);
        setRefetchConexiones(true);
        setItemsSeleccionados([]);
      } else {
        toast.error(data.justificarMinutaManual.valorEsperado);
      }
    }
  });

  const isValidJustificacion = () => {
    if (idJustificacionMasiva === 0) {
      toast.error("Debe seleccionar el motivo de Justificación.");
      return false;
    }

    if (itemsSeleccionados.length === 0) {
      toast.error("Debe seleccionar al menos una conexión para justificar.");
      return false;
    }

    return true;
  };

  const generateInputJustificacion = () => {
    let lista = [];
    itemsSeleccionados.map((conexion) => {
      lista.push(conexion.idConexion);
    });
    return {
      idDelegacion: idDelegacion,
      idJustificacion: idJustificacionMasiva,
      idEvaluacion: dataRegistro?.idEvaluacion,
      codigoCliente: dataRegistro?.codClienteSAP,
      idsConexiones: lista
    };
  };

  const handleJustificar = () => {
    if (isValidJustificacion()) {
      const input = generateInputJustificacion();
      justificarMinuta({ variables: { input: input } });
    }
  };

  // FIN JUSTIFICAR

  return (
    <>
      <Grid container className='minuta-card-white' spacing={1}>
        <Grid size={{ xs: 12 }}>
          <div className='section-title'>Datos</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Contrato</div>
          <div>{dataRegistro?.idEvaluacion}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Delegación</div>
          <div>{delegacion}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 6 }}>
          <div className='minuta-card-label'>Fecha</div>
          <div>{moment().format("DD/MM/YYYY")}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Paciente</div>
          <div>{dataRegistro?.paciente}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>SAP Paciente</div>
          <div>{dataRegistro?.codPacienteSAP}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 6 }}>
          <div className='minuta-card-label'>HC</div>
          <div>{dataRegistro?.idPaciente}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Cliente</div>
          <div>{dataRegistro?.cliente}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>SAP Cliente</div>
          <div>{dataRegistro?.codClienteSAP}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 6 }}>
          <div className='minuta-card-label'>Plan</div>
          <div>({dataRegistro?.codPlanSAP}) {dataRegistro?.modulo}</div>
        </Grid>
      </Grid>
      <br /><br />
      <Grid container className='minuta-card-white' spacing={1}>
        <Grid size={{ xs: 9 }}>
          <div className='section-title'>Detalle</div>
        </Grid>
        <Grid size={{ xs: 3 }}>
          <div style={{ width: '100%', textAlign: 'right' }}>
            <CustomButton
              variant='contained'
              className='margin-right'
              disabled={!allowedWrite || justificarMinutaLoading}
              onClick={handleGenerar}
              size='small'
              isLoading={createMinutaLoading}>

              Generar Minuta
            </CustomButton>
          </div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Cantidad de Conexiones</div>
          <div>{dataRegistro?.cantidadConexion}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Precio Diario</div>
          <div>$ {dataRegistro?.precioDiario}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Precio SAP</div>
          <div>$ {dataRegistro?.precioSAP}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Total</div>
          <div>$ {dataRegistro?.precioTotal}</div>
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <div style={{ display: 'flex', paddingTop: '10px' }}>
            <FormControl sx={{ backgroundColor: 'white', width: '40%' }} size="small">
              <InputLabel id="select-justificacion">Justificación</InputLabel>
              <Select
                labelId="select-justificacion"
                options={justificaciones}
                label='Justificación'
                onChange={(e) => setIdJustificacionMasiva(e.target.value)}
                value={idJustificacionMasiva}
                name='idJustificacion'
                disabled={!allowedWrite || createMinutaLoading}>

                {justificaciones && justificaciones.map((justificacion) => {
                  return <MenuItem key={justificacion.idJustificacion} value={justificacion.idJustificacion}> {justificacion.justificacion} </MenuItem>;
                })}
              </Select>
            </FormControl>
            &nbsp;&nbsp;
            <CustomButton
              variant='outlined'
              isLoading={justificarMinutaLoading}
              disabled={!allowedWrite || createMinutaLoading}
              onClick={handleJustificar}>

              Justificar
            </CustomButton>
          </div>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <JustificarMinutaDetalleItems
            dataRegistro={dataRegistro}
            disabledCheckbox={disabledCheckbox}
            itemsEvaluacion={itemsEvaluacion}
            setItemsEvaluacion={setItemsEvaluacion}
            setItemsSeleccionados={setItemsSeleccionados}
            refetchConexiones={refetchConexiones}
            setRefetchConexiones={setRefetchConexiones} />

        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <GenerarMinutaDetalleDocs
            dataRegistro={dataRegistro}
            disabledCheckbox={disabledCheckbox}
            documentos={documentos}
            documentosSAP={documentosSAP}
            documentosSeleccionados={documentosSeleccionados}
            setDocumentos={setDocumentos}
            setDocumentosSAP={setDocumentosSAP}
            setDocumentosSeleccionados={setDocumentosSeleccionados} />

        </Grid>
        <Grid size={{ xs: 12, md: 12 }} sx={{ marginTop: '10px' }}>
          <TextInput
            value={dataRegistro?.observaciones}
            label="Observaciones"
            placeholder="Observaciones"
            multiline
            rows={3}
            maxLength={2000}
            disabled={true} />

        </Grid>
      </Grid>
    </>);

};